export default [
  {
    value: 'AEROBICS',
    locale: 'message.activityAerobics'
  },
  {
    value: 'CYCLING',
    locale: 'message.activityCycling'
  },
  {
    value: 'DANCING',
    locale: 'message.activityDancing'
  },
  {
    value: 'TAI_CHI',
    locale: "message.activityTaiChi"
  },
  {
    value: 'PILATES',
    locale: 'message.activityPilates'
  },
  {
    value: 'SALSA_DANCING',
    locale: 'message.activitySalsaDancing'
  },
  {
    value: 'SWIMMING',
    locale: 'message.activitySwimming'
  },
  {
    value: 'GYM_ROWING',
    locale: 'message.activityGymRowing'
  },
  {
    value: 'GYM_TREADMILL',
    locale: 'message.activityGymTreadmill'
  },
  {
    value: 'GYM_CYCLING',
    locale: 'message.activityGymCycling'
  },
  {
    value: 'RUNNING',
    locale: 'message.activityRunning'
  },
  {
    value: 'STAIR_WALKING',
    locale: 'message.activityStairWalking'
  },
  {
    value: 'WALKING',
    locale: 'message.activityWalking'
  },
  {
    value: 'GYM_WEIGHTS',
    locale: 'message.activityGymWeights'
  },
  {
    value: 'YOGA',
    locale: 'message.activityYoga'
  },
  {
    value: 'SPORTS',
    locale: 'message.activitySports'
  },
  {
    value: 'SEX',
    locale: 'message.activitySex'
  }
];



// WEBPACK FOOTER //
// ./src/components/Tracking/activityTypes.js